<app-header [class.dark]="theme().cover.design && mode() === 'layout'" [small]="true">
  @if (parentLink()) {
    <a
      appButton
      name="back-to-parent"
      class="back-button"
      location="view-gallery-header"
      [color]="theme().cover.design && mode() === 'layout' ? 'blur' : 'default-opacity'"
      [iconButton]="true"
      appTooltip="Back"
      shape="round"
      height="1"
      [routerLink]="parentLink()"
    >
      <app-svg src="/assets/icons/arrow-left.svg" size="0-5"></app-svg>
    </a>
  }
  @if (showGalleriesButton()) {
    <app-context-menu [options]="{ width: '480px', noSpacing: true }" #treeMenu>
      <button
        appButton
        contextButton
        name="galleries"
        location="view-gallery-header"
        shape="round"
        [color]="theme().cover.design && mode() === 'layout' ? 'blur' : 'default-opacity'"
        appTooltip="Show Galleries"
        height="1"
        size="1"
        [hasIcon]="!isMobile()"
        [iconButton]="isMobile()"
        weight="bold"
      >
        <app-svg src="/assets/icons/menu-list.svg" size="0-5"></app-svg>
        @if (!isMobile()) {
          <span>Galleries</span>
        }
      </button>
      <div contextContent>
        @if (treeMenu.isOpen()) {
          <app-gallery-tree [gallery]="gallery()" [clientMode]="true" (onClose)="treeMenu.close()"></app-gallery-tree>
        }
      </div>
    </app-context-menu>
  }
  <div class="spacer"></div>
  @if (galleryPermissions()?.can_review_if_authenticated && gallery()?.enabled_gallery_statuses.length > 1) {
    <app-context-menu [options]="{ width: '240px', noSpacing: true }" #statusMenu>
      <button
        appButton
        contextButton
        name="gallery-status"
        location="view-gallery-header"
        data-test-id="gallery-status"
        shape="round"
        [color]="theme().cover.design && mode() === 'layout' ? 'blur' : 'default-opacity'"
        class="gallery-status-button"
        appTooltip="Gallery Status"
        height="1"
        size="1"
        [hasIcon]="!isMobile()"
        [iconButton]="isMobile()"
        weight="bold"
      >
        <app-svg
          src="/assets/icons/{{ gallery()?.status | galleryStatusIcon }}.svg"
          [attr.color]="gallery()?.status | galleryStatusColor"
        ></app-svg>
        @if (!isMobile()) {
          <app-svg src="/assets/icons/12/chevron-down.svg" size="-2"></app-svg>
        }
      </button>
      <app-gallery-status-context
        contextContent
        [gallery]="gallery()"
        (onSelectStatus)="updateGalleryStatus($event); statusMenu.close()"
      ></app-gallery-status-context>
    </app-context-menu>
  }
  @if (allowAdvancedMode() && mode() === 'layout') {
    <a
      [routerLink]="['./advanced']"
      appButton
      name="advanced-mode"
      [color]="theme().cover.design && mode() === 'layout' ? 'blur' : 'default-opacity'"
      location="view-gallery-header"
      data-test-id="view-advanced-mode"
      [hasIcon]="!isMobile()"
      [iconButton]="isMobile()"
      shape="round"
      height="1"
      size="1"
      weight="bold"
      appTooltip="Switch to Workflow"
    >
      <app-svg src="/assets/icons/mode-catalog.svg" size="0-5"></app-svg>
      @if (!isMobile()) {
        <span>Workflow</span>
      }
    </a>
  }
  @if (allowAdvancedMode()) {
    @if (mode() === 'advanced') {
      <a
        [routerLink]="['../']"
        appButton
        name="layout"
        [color]="'default'"
        location="view-gallery-header"
        data-test-id="view-layout-mode"
        [hasIcon]="!isMobile()"
        [iconButton]="isMobile()"
        shape="round"
        height="1"
        size="1"
        weight="bold"
        appTooltip="Switch to Layout"
      >
        <app-svg src="/assets/icons/gallery-stand.svg" size="0-5"></app-svg>
        @if (!isMobile()) {
          <span>Layout</span>
        }
      </a>
    }
  } @else {
    @if (galleryPermissions()?.can_review_if_authenticated && mode() === 'layout') {
      <app-view-filter
        [gallery]="gallery()"
        [theme]="theme()"
        [mode]="mode()"
        [galleryPermissions]="galleryPermissions()"
        (onFilterChange)="onFilter($event)"
        #viewFilter
      >
      </app-view-filter>
    }
  }
  @if (gallery()?.download_full_gallery) {
    <app-context-menu [options]="{ width: '240px', noSpacing: true }" #downloadMenu [disabled]="downloadingAll()">
      <button
        appButton
        name="download-all"
        [color]="theme().cover.design && mode() === 'layout' ? 'blur' : 'default-opacity'"
        location="view-gallery-header"
        data-test-id="download-gallery"
        class="download-button"
        shape="round"
        height="1"
        size="1"
        [hasIcon]="!isMobile()"
        [iconButton]="isMobile()"
        weight="bold"
        [hideTextOnMobile]="allowAdvancedMode()"
        appTooltip="Download All"
        toolTipOrigin="top-right"
        [class.disabled]="downloadingAll()"
        contextButton
      >
        <app-svg src="/assets/icons/download.svg" size="0-5"></app-svg>
        @if (!isMobile()) {
          @if (!downloadingAll()) {
            <span>Download</span>
          } @else {
            <span>Downloading...</span>
          }
        }
      </button>
      <div class="button-menu" contextContent>
        @if (downloadMenu.isOpen()) {
          <app-gallery-download-menu-options
            [gallery]="gallery()"
            [includeSubGalleries]="true"
            (onDownload)="download($event); downloadMenu.close()"
          >
          </app-gallery-download-menu-options>
        }
      </div>
    </app-context-menu>
  }
  @if (state.user || guest()?.email) {
    <app-context-menu [options]="{ width: '320px', noSpacing: true }" name="view-gallery context" #menu>
      <div
        contextButton
        appClickTrack
        name="profile-circle"
        location="view-gallery-header"
        class="profile-circle"
        [appTooltip]="(state.user || guest() | userGuestName) + ' (you)'"
        toolTipOrigin="top-right"
        [class.auto-border]="(state.user | avatarType) === 'image'"
      >
        <app-avatar [user]="state.user || guest()"></app-avatar>
      </div>
      <app-view-profile-menu
        [galleryPermissions]="galleryPermissions()"
        [gallery]="gallery()"
        contextContent
        (onClose)="menu.close()"
      ></app-view-profile-menu>
    </app-context-menu>
  }
  @if (
    !state.user &&
    !guest()?.email &&
    galleryPermissions().can_review_if_authenticated &&
    enabledAndAllowedFeedbackOptions()?.length > 0
  ) {
    <div
      class="profile-circle"
      [appTooltip]="(guest() | userGuestName) + ' (you)'"
      toolTipOrigin="top-right"
      (click)="openGuestProfileDialog()"
    >
      <app-avatar [user]="guest()"></app-avatar>
    </div>
  }
</app-header>
